/* eslint-disable react/no-multi-comp  */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';

import Logo from './Logo';
import FlyoutMenu from './FlyoutMenu';
import Nav from './Nav';
import MoveableDiv from './MoveableDiv';

import styles from './styles';

export function withSearch(Header) {
    return class HeaderWithSearch extends Component {
        render() {
            const newProps = {
                isSearchPage: true
            };
            return <Header {...this.props} {...newProps} />;
        }
    };
}

export function isFloating(Header) {
    return class HeaderFloating extends Component {
        render() {
            const newProps = {
                floating: true
            };
            return <Header {...this.props} {...newProps} />;
        }
    };
}

class Header extends Component {
    static propTypes = {
        domain: PropTypes.string.isRequired,
        floating: PropTypes.bool.isRequired,
        isSearchPage: PropTypes.bool.isRequired
    }

    static defaultProps = {
        floating: false,
        isSearchPage: false
    }

    state = {
        flyoutOpen: false
    }

    toggleFlyout = () => {
        this.setState({ flyoutOpen: !this.state.flyoutOpen });
    }

    render() {
        return (
            <div
                className={
                    this.props.floating ?
                        css(styles.headerController, styles.headerController_fixed) :
                        css(styles.headerController)
                }
            >
                <header
                    role="banner"
                    className={css(styles.header, styles.containerRelative)}
                >
                    <div className={css(styles.contentFloating)}>
                        <div className={css(styles.containerTable)}>
                            <div className={css(styles.containerTableChildCellAlignMiddle)}>
                                <div>
                                    <Logo
                                        flyoutOpen={this.state.flyoutOpen}
                                        handleFlyoutMenu={this.toggleFlyout}
                                        domain={this.props.domain}
                                    />
                                    <FlyoutMenu flyoutOpen={this.state.flyoutOpen} />
                                </div>
                            </div>
                            <div className={css(styles.containerTableChildCellMiddleAlignMiddle)} />
                            <div className={css(styles.containerTableChildCellAlignMiddle)}>
                                <Nav />
                            </div>
                        </div>
                    </div>
                </header>
                {
                    this.props.isSearchPage ?
                        <MoveableDiv domain={this.props.domain} /> : null
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    domain: state.config.domain
});

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx